import createModel from '../lib/create_model';

var EmailPreview = createModel({
  modelName: 'EmailPreview',

  properties: {
    excerpt: String,
    from: String,
    subject: String,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default EmailPreview;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/content_preview/email_preview.js